module.exports = __webpack_public_path__ + "img/patient.c78acded.jpg";